
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/return",
      function () {
        return require("private-next-pages/[lang]/return/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/return"])
      });
    }
  